import { ANCILLARY_FILTER_DATA_REQUEST, ANCILLARY_FILTER_DATA_SUCCESS, ANCILLARY_FILTER_DATA_FAILURE, ANCILLARY_FILTER_DATA_LOADING, ANCILLARY_CAT_DETAILS_DATA_REQUEST, ANCILLARY_CAT_DETAILS_DATA_SUCCESS, ANCILLARY_CAT_DETAILS_DATA_FAILURE, ANCILLARY_CAT_DETAILS_DATA_LOADING, ANCILLARY_NET_CAT_DETAILS_DATA_REQUEST, ANCILLARY_NET_CAT_DETAILS_DATA_SUCCESS, ANCILLARY_NET_CAT_DETAILS_DATA_FAILURE, ANCILLARY_NET_CAT_DETAILS_DATA_LOADING, ANCILLARY_EXPORT_LINK_LOADING, ANCILLARY_EXPORT_LINK_FAILURE, ANCILLARY_EXPORT_LINK_SUCCESS, ANCILLARY_EXPORT_LINK_REQUEST, ANCILLARY_CATEGORY_VIEW_DATA_REQUEST, ANCILLARY_CATEGORY_VIEW_DATA_LOADING, ANCILLARY_CATEGORY_VIEW_DATA_SUCCESS, ANCILLARY_CATEGORY_VIEW_DATA_FAILURE } from '../../actionTypes';


export const labsFilterDataRequest = (payload: any) => ({
  type: ANCILLARY_FILTER_DATA_REQUEST,
  payload,
});

export const labsFilterDataSuccess = (payload: any) => ({
  type: ANCILLARY_FILTER_DATA_SUCCESS,
  payload,
});
export const labsFilterDataError = (payload: any) => ({
  type: ANCILLARY_FILTER_DATA_FAILURE,
  payload,
});
export const labsFilterDataLoading = (payload: any) => ({
  type: ANCILLARY_FILTER_DATA_LOADING,
  payload,
});

export const labsDetailsDataRequest = (payload: any) => ({
  type: ANCILLARY_CAT_DETAILS_DATA_REQUEST,
  payload,
});

export const labsDetailsDataSuccess = (payload: any) => ({
  type: ANCILLARY_CAT_DETAILS_DATA_SUCCESS,
  payload,
});
export const labsDetailsDataError = (payload: any) => ({
  type: ANCILLARY_CAT_DETAILS_DATA_FAILURE,
  payload,
});
export const labsDetailsDataLoading = (payload: any) => ({
  type: ANCILLARY_CAT_DETAILS_DATA_LOADING,
  payload,
});

export const labsNetDetailsDataRequest = (payload: any) => ({
  type: ANCILLARY_NET_CAT_DETAILS_DATA_REQUEST,
  payload,
});

export const labsNetDetailsDataSuccess = (payload: any) => ({
  type: ANCILLARY_NET_CAT_DETAILS_DATA_SUCCESS,
  payload,
});
export const labsNetDetailsDataError = (payload: any) => ({
  type: ANCILLARY_NET_CAT_DETAILS_DATA_FAILURE,
  payload,
});
export const labsNetDetailsDataLoading = (payload: any) => ({
  type: ANCILLARY_NET_CAT_DETAILS_DATA_LOADING,
  payload,
});

export const labsDetailsExportRequest = (payload: any) => ({
  type: ANCILLARY_EXPORT_LINK_REQUEST,
  payload,
});

export const labsDetailsExportSuccess = (payload: any) => ({
  type: ANCILLARY_EXPORT_LINK_SUCCESS,
  payload,
});
export const labsDetailsExportError = (payload: any) => ({
  type: ANCILLARY_EXPORT_LINK_FAILURE,
  payload,
});
export const labsDetailsExportLoading = (payload: any) => ({
  type: ANCILLARY_EXPORT_LINK_LOADING,
  payload,
});

export const labsCategoryViewRequest = (payload: any) => ({
  type: ANCILLARY_CATEGORY_VIEW_DATA_REQUEST,
  payload,
});

export const labsCategoryViewSuccess = (payload: any) => ({
  type: ANCILLARY_CATEGORY_VIEW_DATA_SUCCESS,
  payload,
});
export const labsCategoryViewError = (payload: any) => ({
  type: ANCILLARY_CATEGORY_VIEW_DATA_FAILURE,
  payload,
});
export const labsCategoryViewLoading = (payload: any) => ({
  type: ANCILLARY_CATEGORY_VIEW_DATA_LOADING,
  payload,
});